import { Heading } from "@planningcenter/doxy-web"
import { css } from "@emotion/react"
import { Link } from "react-router-dom"
import { Icon } from "source/shared/components"
import { fetchRecurringDonations, fetchPledges } from "../queries"
import { useQuery } from "@tanstack/react-query"
import { AlertMessage, Loading } from "source/shared/components"
import RecurringDonationsList from "./RecurringDonationsList"
import PledgesList from "./PledgesList"

export default function PlannedGiving() {
  const {
    data: { recurringDonations = [] } = {},
    isLoading: isLoadingRecurringDonations,
    isError: isErrorRecurringDonations,
  } = useQuery({
    queryKey: ["RecurringDonations"],
    queryFn: fetchRecurringDonations,
  })

  const {
    data: { pledges = [], pledgeCampaigns = [], jointGiver = null } = {},
    isLoading: isLoadingPledges,
    isError: isErrorPledges,
  } = useQuery({
    queryKey: ["Pledges"],
    queryFn: () => fetchPledges(),
  })

  return (
    <section>
      <div className="d-f fd-c g-2">
        <div className="d-n d-f@md">
          <Heading level={1} size={2} text="Planned giving" />
        </div>
        {isErrorRecurringDonations ? (
          <AlertMessage type="error" icon="general#exclamation-triangle">
            Something went wrong. Please try again.
          </AlertMessage>
        ) : isLoadingRecurringDonations ? (
          <Loading message="Loading" />
        ) : (
          <>
            <div
              className="d-f fd-c g-2 p-2"
              css={css`
                border: 1px solid var(--color-static-gray93);
                border-radius: 8px;
              `}
            >
              <div className="d-f jc-sb ai-c">
                <Heading level={2} size={3} text="Recurring donations" />
                <Link
                  to="/giving?recurring=true"
                  className="btn outline-btn sm-btn d-f g-1"
                >
                  <Icon
                    symbol="general#plus"
                    aria-hidden="true"
                    css={css`
                      height: 12px;
                      width: 12px;
                    `}
                  />
                  New
                </Link>
              </div>
              {recurringDonations && (
                <RecurringDonationsList
                  recurringDonations={recurringDonations}
                />
              )}
            </div>
          </>
        )}
        {isErrorPledges ? (
          <AlertMessage type="error" icon="general#exclamation-triangle">
            Something went wrong. Please try again.
          </AlertMessage>
        ) : isLoadingPledges ? (
          <Loading message="Loading" />
        ) : (
          pledges &&
          pledgeCampaigns &&
          pledges.length > 0 && (
            <div
              className="d-f fd-c g-2 p-2"
              css={css`
                border: 1px solid var(--color-static-gray93);
                border-radius: 8px;
              `}
            >
              <Heading level={2} size={3} text="Pledges" />
              <PledgesList
                jointGiver={jointGiver}
                pledgeCampaigns={pledgeCampaigns}
                pledges={pledges}
              />
            </div>
          )
        )}
      </div>
    </section>
  )
}
